import { render, staticRenderFns } from "./createonlinetest.vue?vue&type=template&id=d9874408&"
import script from "./createonlinetest.vue?vue&type=script&lang=js&"
export * from "./createonlinetest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports